<template>
  <div class="guide">
    <div class="form-header">
      <h3>Minha Conta</h3>
      <hr>
    </div>
		<b-tabs v-model="tabIndex" class="guide-tabs" content-class="mt-3">
			<b-tab title="Cadastro" active>
				<b-form @submit.prevent="save()" class="registration-form"  id="form" autocomplete="off">
					<b-form-row>
						<b-col sm="2">
							<img class="guide-photo-img" :src="guide.photoPath">
						</b-col>
						<b-col sm="10">
							<b-form-row>
								<b-col sm="4">
									<labeled-input id="name" v-model="guide.name" label="Nome" placeholder="Digite o nome..." disabled/>
								</b-col>
								<b-col sm="4">
									<labeled-input id="email" v-model="guide.email" label="E-mail" placeholder="Digite o e-mail..." disabled/>
								</b-col>
								<b-col sm="4">
									<labeled-input id="cpf" v-model="guide.cpf" label="CPF" placeholder="Digite o CPF..." disabled/>
								</b-col>
							</b-form-row>
							<b-form-row>
								<b-col sm="4">
									<labeled-input id="nickname" v-model="guide.nickname" label="Apelido" placeholder="Digite o apelido..." required/>
								</b-col>
								<b-col sm="4">
									<b-form-group label="Nascimento" label-for="birthDate">
										<blumar-date-input id="birthDate" v-model="guide.birthDate" size="md" required/>
									</b-form-group>
								</b-col>
								<b-col sm="4">
									<labeled-select id="paymentType" v-model="guide.paymentType" label="Pagamento" :options="paymentTypes" :show-labels="false" :placeholder="'--Selecione'" />
								</b-col>
							</b-form-row>
							<b-form-row>
								<b-col>
									<b-form-group label="Descrição" label-for="description">
										<b-form-textarea
											id="description"
											v-model="guide.description"
											rows="4"
											max-rows="4"
										></b-form-textarea>
									</b-form-group>
								</b-col>
							</b-form-row>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col sm="2">
							<b-form-group label="Cidade" label-for="cities">
								<city-select id="cities" v-model="guide.city" required/>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<labeled-input id="address" v-model="guide.address" label="Endereço" placeholder="Digite o endereço..."/>
						</b-col>
						<b-col sm="2">
							<labeled-input id="zipCode" v-model="guide.zipCode" label="CEP" mask="99999-999"/>
						</b-col>
						<b-col sm="2">
							<labeled-input id="phone" v-model="guide.phone" label="Telefone"/>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col sm="2">
							<labeled-input id="rg" v-model="guide.rg" label="RG" placeholder="Digite o RG..."/>
						</b-col>
						<b-col sm="2">
							<labeled-input id="pis" v-model="guide.pis" label="PIS" placeholder="Digite o PIS..."/>
						</b-col>
						<b-col sm="2">
							<labeled-input id="rne" v-model="guide.rne" label="RNE" placeholder="Digite o RNE..."/>
						</b-col>
						<b-col sm="2">
							<labeled-input id="rneIssuingBody" v-model="guide.rneIssuingBody" label="Orgao do RNE" placeholder="Digite o orgao de emissao do RNE..."/>
						</b-col>
						<b-col sm="2">
							<b-form-group label="Data do RNE" label-for="rneDate">
								<blumar-date-input id="rneDate" v-model="guide.rneDate" size="md" />
							</b-form-group>
						</b-col>
						<b-col sm="2">
							<labeled-input id="embraturCode" v-model="guide.embraturCode" label="Embratur" placeholder="Digite o código embratur..."/>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col sm="3">
							<labeled-input id="cnh" v-model="guide.cnh" label="CNH" placeholder="Digite o número da CNH"/>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Validade CNH" label-for="cnhExpirationDate">
								<blumar-date-input id="cnhExpirationDate"  v-model="guide.cnhExpirationDate" placeholder="Selecione a data de expiração" :required="false" size="md"/>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Data da Primeira CNH" label-for="firstCnhDate">
								<blumar-date-input id="firstCnhDate"  v-model="guide.firstCnhDate" placeholder="Selecione a data" :required=false size="md"></blumar-date-input>
							</b-form-group>
						</b-col>
						<b-col sm="3">
							<b-form-group label="Categoria CNH" label-for="cnhCategory">
								<multiselect id="cnhCategory" v-model="guide.cnhCategory" :options="cnhCategoryTypes" placeholder="Selecione" openDirection="bottom" selectLabel="" deselectLabel="" selectedLabel="" required></multiselect>
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<labeled-input id="schooling" v-model="guide.schooling" label="Escolaridade" placeholder="Descreva a escolaridade..."/>
						</b-col>
						<b-col>
							<labeled-input id="higherEducation" v-model="guide.higherEducation" label="Formacao" placeholder="Descreva a formacao..."/>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<labeled-input id="motherName" v-model="guide.motherName" label="Nome da Mãe" placeholder="Digite o nome da mãe..."/>
						</b-col>
						<b-col>
							<labeled-input id="fatherName" v-model="guide.fatherName" label="Nome do Pai" placeholder="Digite o nome do pai..."/>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-group label="Operadoras Trabalhadas" label-for="operators">
								<b-form-textarea
									id="operators"
									v-model="guide.operators"
									rows="2"
									max-rows="2"
								></b-form-textarea>
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<b-form-group id="generalLanguagesFormGroup" label="Idiomas" label-for="generalLanguages">
								<multiselect id="generalLanguages" :multiple="true" v-model="guide.languages" :options="generalLanguages" track-by="id" label="name" placeholder="Selecione" openDirection="top" selectLabel="" deselectLabel="" selectedLabel=""></multiselect>
							</b-form-group>
						</b-col>
					</b-form-row>
					<b-form-row v-if="guide && guide.hasSavedProfileInfo">
						<b-col>
							<b-link button @click="sendResetPassword()">Trocar Senha</b-link>
						</b-col>
					</b-form-row>
				</b-form>
			</b-tab>
			<b-tab title="Veículos">
				<i class="material-icons addAccount mb-3" title="Adicionar veículo" @click="addVehicle">add_circle</i>
				<div v-for="(vehicle, index) in guide.vehicles" :key="index" class="mb-4">
					<div>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<b>Veículo: {{ vehicle.model }}</b>
							</div>
							<div>
								<i class="material-icons" style="cursor: pointer" @click="removeVehicle(index)" title="Excluir veículo">delete</i>
							</div>
						</div>
						<hr />
						<b-form-row>
							<b-col sm="2">
								<labeled-input id="model" v-model="vehicle.model" label="Modelo" placeholder="Digite o modelo" required/>
							</b-col>
							<b-col sm="2">
								<labeled-input id="licensePlate" v-model="vehicle.licensePlate" label="Placa" placeholder="Digite a placa" required/>
							</b-col>
							<b-col sm="2">
								<labeled-input id="year" v-model="vehicle.year" label="Ano" placeholder="Digite o ano" required/>
							</b-col>
							<b-col sm="2">
								<labeled-input id="modelYear" v-model="vehicle.modelYear" label="Ano do Modelo" placeholder="Digite o ano do modelo" required/>
							</b-col>
							<b-col sm="2">
								<labeled-input id="color" v-model="vehicle.color" label="Cor" placeholder="Digite a cor" required/>
							</b-col>
							<b-col sm="2">
								<labeled-input id="doors" v-model="vehicle.doors" label="Portas" placeholder="Digite o número de portas" required/>
							</b-col>
						</b-form-row>
						<b-form-row>
							<b-col sm="2">
								<b-form-group label="Câmbio" label-for="transmission">
									<multiselect id="transmission" v-model="vehicle.transmission" :options="transmissionTypes" placeholder="Selecione" openDirection="bottom" selectLabel="" deselectLabel="" selectedLabel="" required></multiselect>
								</b-form-group>
							</b-col>
							<b-col sm="2">
								<b-form-group label="Tipo de Estofado" label-for="upholstery">
									<multiselect id="upholstery"  v-model="vehicle.upholstery" :options="upholsteryTypes" placeholder="Selecione" openDirection="bottom" selectLabel="" deselectLabel="" selectedLabel="" required></multiselect>
								</b-form-group>
							</b-col>
							<b-col sm="2">
								<b-form-group label="Combustível" label-for="fuelType">
									<multiselect id="fuelType" v-model="vehicle.fuelType" :options="fuelTypes" placeholder="Selecione" openDirection="bottom" selectLabel="" deselectLabel="" selectedLabel="" required></multiselect>
								</b-form-group>
							</b-col>
							<b-col sm="2" align-self="center">
								<b-form-row>
									<b-col>
										<b-form-checkbox v-model="vehicle.gasKit" required><b>Kit Gás</b></b-form-checkbox>
									</b-col>
								</b-form-row>
								<b-form-row>
									<b-col sm>
										<b-form-checkbox v-model="vehicle.ownVehicle" required><b>Veículo Próprio</b></b-form-checkbox>
									</b-col>
								</b-form-row>
							</b-col>
							<b-col sm="1" align-self="center">
								<b-form-row>
									<b-col>
										<b-form-checkbox v-model="vehicle.insurance" required><b>Seguro</b></b-form-checkbox>
									</b-col>
								</b-form-row>
								<b-form-row>
									<b-col>
										<b-form-checkbox v-model="vehicle.thirdPartyInsurance"  required><b>Terceiros</b></b-form-checkbox>
									</b-col>
								</b-form-row>
							</b-col>
							<b-col sm="2">
								<labeled-input id="insuranceCompany"  v-model="vehicle.insuranceCompany" label="Seguradora" placeholder="Digite a seguradora" required/>
							</b-col>
							<b-col sm="1">
								<b-form-group label="Validade" label-for="insuranceExpirationDate">
									<blumar-date-input v-model="vehicle.insuranceExpirationDate"  placeholder="Do seguro" size="md" required></blumar-date-input>
								</b-form-group>
							</b-col>
						</b-form-row>
						<b-form-row>
							<b-col>
								<b-form-group label="Observações" label-for="observation">
									<b-textarea v-model="vehicle.observation" rows="3" required></b-textarea>
								</b-form-group>
							</b-col>
						</b-form-row>
					</div>
					<hr v-if="index < guide.vehicles.length - 1" class="section-divider" />
				</div>
			</b-tab>
			<b-tab title="Dependentes">
				<div>
					<i class="material-icons addAccount mb-3" title="Adicionar dependente" @click="addDependent">add_circle</i>
					<div v-for="(dependent, index) in guide.dependents" :key="index" class="mb-4">
						<div>
							<div class="d-flex align-items-center justify-content-between">
								<div>
									<b>Dependente: {{ dependent.name }}</b>
								</div>
								<div>
									<i class="material-icons" style="cursor: pointer" @click="removeDependent(index)" title="Excluir dependente">delete</i>
								</div>
							</div>
							<hr />
							<b-form-row>
								<b-col sm="3">
									<labeled-input id="name"  v-model="dependent.name" label="Nome" placeholder="Digite o nome"/>
								</b-col>
								<b-col sm="2">
									<b-form-group label="Gênero" label-for="gender">
										<multiselect id="gender"  v-model="dependent.gender" :options="genderTypes" placeholder="Selecione" openDirection="bottom" selectLabel="" deselectLabel="" selectedLabel="" required></multiselect>
									</b-form-group>
								</b-col>
								<b-col sm="2">
									<b-form-group label="Data de Nascimento" label-for="birthDate">
										<blumar-date-input v-model="dependent.birthDate"  placeholder="Digite a data de nascimento" size="md" required></blumar-date-input>
									</b-form-group>
								</b-col>
								<b-col sm="3" >
									<labeled-input id="city"  v-model="dependent.city" label="Cidade" placeholder="Digite a cidade" required/>
								</b-col>
								<b-col sm="2" >
									<labeled-input id="cpf"  v-model="dependent.cpf" label="CPF" placeholder="Digite o CPF" required/>
								</b-col>
							</b-form-row>
						</div>
						<hr v-if="index < guide.dependents.length - 1" class="section-divider" />
					</div>
				</div>
			</b-tab>
		</b-tabs>
		<float-submit-button title="Salvar Guia" @action="save" formId="form" id=save-button class="float-button"></float-submit-button>
	</div>
</template>

<script>
import FormHeader from "../../components/shared/FormHeader.vue";
import FormButton from "../../components/shared/FormButton.vue";
import CitySelect from "../../components/shared/CitySelect.vue";
import FloatButton from "../../components/shared/FloatButton.vue";
import BlumarDateInput from "../../components/shared/BlumarDateInput.vue";
import GuideService from "../../service/GuideService";
import GeneralLanguageService from "../../service/GeneralLanguageService";
import { requestAction, fetchModel } from '../../utils';
import GuideVehicle from '../../model/GuideVehicle';
import GuideDependent from '../../model/GuideDependent';

let GuidePaymentType = {
  INVOICE: { id: 1, name: "Nota Fiscal" },
  RPA: { id: 2, name: "RPA" },
};

export default {
  components: {
    formheader: FormHeader,
    formbutton: FormButton,
    floatbutton: FloatButton,
    BlumarDateInput: BlumarDateInput,
    CitySelect: CitySelect
  },
  data() {
    return {
      userId: this.$store.state.user.id,
      guide: this.$store.getters.user,
      guideService: new GuideService(),
      generalLanguageService: new GeneralLanguageService(),
      paymentTypes: [
				GuidePaymentType.INVOICE,
				GuidePaymentType.RPA,
			],
      generalLanguages: [],
			tabIndex: this.mainTabIndex,
      fuelTypes: ["Gasolina", "Etanol", "Flex", "Diesel", "Elétrico"],
      transmissionTypes: ["Manual", "Automático"],
      upholsteryTypes: ["Couro", "Sintético"],
			genderTypes: ["Masculino", "Feminino"],
			cnhCategoryTypes: ["A", "B", "AB", "C", "D", "AD", "E"],
    };
  },
  async mounted() {
    this.guide = await fetchModel('guia', () => this.guideService.get());
		this.generalLanguages = await fetchModel('idiomas gerais', () => this.generalLanguageService.list());

    if(!this.guide.hasSavedProfileInfo) {
      this.$store.dispatch("showAlert", {
        message: "Confirme as informações da conta.",
        code: 0,
        style: "warning"
      });
    }
  },
  methods: {
    async save() {
			if(!this.validateFields()) return false;
      let success = "Informações salvas com sucesso!";
      let failure = "Erro ao salvar as informações! ";
      if(!this.guide.hasSavedProfileInfo) {
        this.guide.hasSavedProfileInfo = true;
        var redirectRoute = '/welcome';
      }
      this.guide = await requestAction(success, failure, () => this.guideService.update(this.guide));
      this.$router.push({path: redirectRoute});
    },
    validateFields() {
			if(this.guide.city == null) {
        this.$store.dispatch("showAlert", {
            message: "O campo Cidade é obrigatório! ",
            code: 0,
            style: "warning"
          });
        return false;
			}
			return true;
		},
    sendResetPassword() {
			if(!confirm("Deseja realmente trocar a sua senha do sistema?")) return;
      let success = `Email de troca de senha foi enviado para ${this.guide.email}`;
      let failure = "Erro ao enviar email de troca de senha";
      requestAction(success, failure, () => this.guideService.sendResetPassword(this.guide.email));
    },
		addVehicle() {
    	this.guide.vehicles.push(new GuideVehicle);
  	},
		removeVehicle(index) {
			if (window.confirm("Deseja realmente excluir este veículo do cadastro do guia?")) {
				this.guide.vehicles.splice(index, 1);
			}
		},
			addDependent() {
			this.guide.dependents.push(new GuideDependent);
		},
		removeDependent(index) {
			if (window.confirm("Deseja realmente excluir este dependente do cadastro do guia?")) {
			this.guide.dependents.splice(index, 1);
				}
		},
  }
};
</script>

<style scoped>
.guide {
  max-width: 90%;
  margin: 0% auto 5%;
}

.form-header {
  margin-top: 3%;
  margin-bottom: 2%;
}

.guide-photo-img {
  max-width: 100%;
}

.float-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.addAccount {
  cursor: pointer;
}

.section-divider {
	border: 1px dashed grey;
}

</style>



// WEBPACK FOOTER //
// src/components/users/Guide.vue